// Sentry initialisation for the browser.
//
// Imported first in main.tsx so it is running before React mounts and can
// capture errors thrown during the initial render.
import * as Sentry from "@sentry/react";

// Injected by vite.config.ts from Vercel's VERCEL_GIT_COMMIT_SHA.
declare const __APP_RELEASE__: string;

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,

    // Tags every event with the deployed commit, so Sentry's GitHub
    // integration can attribute an error to the change that caused it.
    release: typeof __APP_RELEASE__ === "string" ? __APP_RELEASE__ : undefined,

    // Errors are always captured; this samples performance traces only.
    tracesSampleRate: 0.1,

    // Estimates contain customer names, addresses and prices. Do not let the
    // SDK attach request bodies or IP addresses by default.
    sendDefaultPii: false,
  });
}

export { Sentry };
